import { Fragment, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../models/app-translation-keys";

import "./LandingPage.scss";

import { Card } from "primereact/card";

import { useNavigationService } from "../../../hooks/useNavigationService";

const RawLandingPage: FunctionComponent = () => {
  const { t } = useTranslation();

  const navigationService = useNavigationService();

  const landingPageTranslationsKeys = translationKeys.pages.landingPage;

  const availableFeatures = navigationService.availableFeatures;

  return (
    <div className="landing-container">
      <div className="landing-page-header">
        <h1 className="landing-page-header-title">
          <span>{t(landingPageTranslationsKeys.title)}</span>{" "}
          <span className="landing-page-header-title-app">{t(translationKeys.app.title)}</span>
        </h1>

        <h3 className="landing-page-header-subtitle">{t(landingPageTranslationsKeys.subTitle)}</h3>
      </div>

      {availableFeatures.length > 0 ? (
        <div className={`features features-${availableFeatures.length}`}>
          {availableFeatures.map(feature => (
            <Fragment key={feature.route.path}>{feature.card}</Fragment>
          ))}
        </div>
      ) : (
        <div className="features feature-list-error-card">
          <Card title={<FontAwesomeIcon icon={faTriangleExclamation} size="2x" />}>
            <h4>{t(landingPageTranslationsKeys.noAvailableFeatures.title)}</h4>

            <p>{t(landingPageTranslationsKeys.noAvailableFeatures.description)}</p>
          </Card>
        </div>
      )}
    </div>
  );
};

export const LandingPage = observer(RawLandingPage);
